<template>
  <div class="widget-header">
    <slot name="header"></slot>
  </div>
</template>